<template>
<div class="chapter">
<div class="inner_page">
<p class="pn"><a href="#/DeathsShadow_toc#part-1">PART ONE</a></p><p class="pt">A Whole New World</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DeathsShadow_part-1.vue?55a51194